import { useMemo } from 'react';

export default function useDefinitions() {
  return useMemo(() => ({
    entityName: 'Page',
    entityNamePlural: 'Pages',
    entityNameModule: 'path',
  }), [])
}
